import { HttpInterceptorFn } from '@angular/common/http';

export const jwtInterceptor: HttpInterceptorFn = (request, next) => {
  const token = localStorage.getItem('token');
  if (!request.url.includes('api.talkjs.com')) {
    if (token) {
      const parsedResponse: any = JSON.parse(token);
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${parsedResponse.token}`,
        },
      });
    }
  }
  return next(request);
};
